import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Expo Countries',
  basePath: '/expo-countries',
  columns: [
    { key: 'continent_name', label: 'Continent', sortable: true },
    { key: 'expo_regions_names', label: 'Expo Regions', sortable: false },
    { key: 'country', label: 'Country', sortable: true },
  ],
  fields: [
    { key: 'continent', label: 'Continent', type: 'async-select',
      optionsUrl: '/expo-continents/options', defaultValue: '1', required: true },
    { key: 'expo_regions', label: 'Expo Regions', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/expo-regions/options' },
    { key: 'country', label: 'Country', type: 'text', required: true },
  ],
  defaultSort: { field: 'country', dir: 'asc' },
});
